import { INVALID_VALIDATOR } from 'constants/errors';

// Temporary while country values are inconsistent
import { LocationModel } from 'forms/shared/types';
import { getCountryValue } from 'helpers/locations/locations';
import { BaseCustomValidator } from '../types';
import { EmptyUSLocationInstance } from '../../models/location/instance';

const locationBaseValidator: BaseCustomValidator<LocationModel> = (validateModel) => (
  value,
  options,
  key,
  attributes,
  globalOptions
) => {
  const { validator } = options;
  if (!validator) { return INVALID_VALIDATOR; }

  const data = { ...EmptyUSLocationInstance, ...value };

  const locationErrors = validateModel(
    {
      ...data,
      country: getCountryValue(data?.country),
    },
    validator,
    { ...globalOptions, ...options }
  );

  if (locationErrors !== true) { return locationErrors; }

  return null;
};

export default locationBaseValidator;
